export default __webpack_public_path__ + "static/media/Eternal Faith Tasset.d7b0e149.jpg";